import { render, staticRenderFns } from "./PrizeDetail.vue?vue&type=template&id=7a33012f&scoped=true"
import script from "./PrizeDetail.vue?vue&type=script&lang=js"
export * from "./PrizeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a33012f",
  null
  
)

export default component.exports